import { IGameFeatures, Locale } from "@game-studio/arcade-base";

export const features: Record<Locale, IGameFeatures> = {
    'dk-dk': {},
    'es-es': {
        swipeToBuy: false,
        colourBlindMode: false,
        newStyleHTP: true,
        maxAutoBuys: 0,
        showSessionData: true,
        enableSessionManager: true,
        showSessionStatusInSettings: false,
        // includeLobbyInDesktopSettings: false,
        seperateMusicSoundControls: false,
        hasChat: true,
        batchLoadAssets: false,
        initialBalanceCheck: { shouldCheckBalance: true, minBalance: 200 }
    },
    'it-it': {
        swipeToBuy: false,
        colourBlindMode: false,
        newStyleHTP: true,
        maxAutoBuys: 0,
        showSessionData: true,
        enableSessionManager: false,
        showSessionStatusInSettings: true,
        seperateMusicSoundControls: false,
        hasChat: true,
        batchLoadAssets: false,
        initialBalanceCheck: { shouldCheckBalance: true, minBalance: 200 }
    },
    'se-se': {},
    'en-gb': {
        swipeToBuy: false,
        colourBlindMode: false,
        newStyleHTP: true,
        sessionDataJustification: {
            portrait: 'default',
            landscape: 'default'
        },
        showSessionData: true,
        hasChat: true,
        batchLoadAssets: false
    }
};